import { useState } from "react";
import RightWrapper from "../../../Components/CommonComponents/ComponentWrapper";
import CustomTable from "../../../Components/CommonComponents/CustomTable";
import { SmallSwitchMenu } from "../../../Components/CommonComponents/SmallSwitchMenu";
import { useCheckRole, useGetLoggedInUser } from "../../../UtilityHookFunctions/LoggedInUser";
import { useNavigate } from "react-router-dom";
import TherapyModuleTabs from "../Alternative_Therapies/TherapyModuleTabs";
import TableActionButton from "../../../Components/CommonComponents/TableActionButton";

const DoctorBidButtons = ({ item }) => {
  const navigate = useNavigate();
  return (
    <>
      <TableActionButton onClick={() => navigate(`/Bids/${item?.bidOn}`)}>View Request</TableActionButton>
      <TableActionButton variant="primary" onClick={() => navigate(`/Bids/review/${item?._id}`)}>
        Review
      </TableActionButton>
    </>
  );
};

const OpenRequestButtons = ({ item }) => {
  const navigate = useNavigate();
  return (
    <>
      <TableActionButton onClick={() => navigate(`/Bids/${item?._id}`)}>View Request</TableActionButton>
      <TableActionButton variant="primary" onClick={() => navigate(`/Bids/${item?._id}/create`)}>
        Bid
      </TableActionButton>
    </>
  );
};

const MyBidButtons = ({ item }) => {
  const navigate = useNavigate();
  return (
    <>
      <TableActionButton onClick={() => navigate(`/Bids/${item?.bidOn?.id}`)}>View Request</TableActionButton>
      {item?.status === "bid" && item?.bidOn?.status === "bid" && (
        <TableActionButton variant="primary" onClick={() => navigate(`/Bids/${item?.bidOn?.id}/create`)}>
          Edit Bid
        </TableActionButton>
      )}
    </>
  );
};

const DoctorMenu = { "Bid Requests": "bid", Won: "treating" };
const ConsultantMenu = { "Open Requests": "open", "My Bids": "mine" };

const BidsTable = () => {
  const checkrole = useCheckRole();
  const user = useGetLoggedInUser();
  const isConsultant = checkrole("consultant");
  const menu = isConsultant ? ConsultantMenu : DoctorMenu;
  const [chosen, setselectedmenu] = useState(null);
  const selectmenu = menu[chosen] ? chosen : Object.keys(menu)[0];
  const view = menu[selectmenu];

  let table;
  if (!isConsultant) {
    table = {
      tablekeys: ["therapy", "bidder_name", "bidPrice", "duration", "bidDate"],
      customHead: ["Therapy", "Consultant", "Price", "Duration (Days)", "Bid Date"],
      fetchUrl: "bid?",
      Queries: { status: view },
      OtherModificationButton: DoctorBidButtons,
    };
  } else if (view === "open") {
    table = {
      tablekeys: ["therapy", "duration", "note"],
      customHead: ["Therapy", "Expected Duration (Days)", "Note"],
      fetchUrl: "alternative_therapy/list?",
      Queries: { search: true, status: "bid", therapy: user?.typeOfConsultant },
      OtherModificationButton: OpenRequestButtons,
    };
  } else {
    table = {
      tablekeys: ["therapy", "bidPrice", "duration", "bidDate", "status"],
      customHead: ["Therapy", "Bid Price", "Duration (Days)", "Bid Date", "Result"],
      fetchUrl: `bid/mybids/${user?._id}`,
      Queries: {},
      OtherModificationButton: MyBidButtons,
    };
  }

  return (
    <RightWrapper>
      <div className="px-2 py-4 md:px-4">
        <TherapyModuleTabs />
        <SmallSwitchMenu options={menu} selectmenu={selectmenu} setselectedmenu={setselectedmenu} />
        <CustomTable key={selectmenu} {...table} DeleteUrl={false} View={false} />
      </div>
    </RightWrapper>
  );
};

export default BidsTable;
